import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const LockIcon: FC<IconProps> = ({ ...props }) => (
  <BaseIcon viewboxSize="sm" {...props}>
    <path
      clipRule="evenodd"
      d="M12.1021 7.00537C12.6064 7.0565 13 7.48217 13 8V13C13 13.5178 12.6064 13.9435 12.1021 13.9946L12 14H4C3.48217 14 3.0565 13.6064 3.00537 13.1021L3 13V8C3 7.44772 3.44772 7 4 7H4.5V5.5C4.5 3.567 6.067 2 8 2C9.933 2 11.5 3.567 11.5 5.5V7H12L12.1021 7.00537ZM10.5 7V5.5C10.5 4.11929 9.38071 3 8 3C6.61929 3 5.5 4.11929 5.5 5.5V7H10.5ZM4 13H12V8H4V13Z"
      fillRule="evenodd"
    />
  </BaseIcon>
);
